/**
 * Các hàm tiện ích để định dạng ngày tháng
 */

/**
 * Định dạng chuỗi ngày tháng theo định dạng Việt Nam: "HH:mm - dd/MM/yyyy"
 * @param dateString - Chuỗi ngày tháng ISO hoặc chuỗi ngày tháng
 * @returns Chuỗi ngày tháng đã được định dạng
 */
export const formatDateTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original string if invalid
    }
    
    // Format time: HH:mm
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const time = `${hours}:${minutes}`;
    
    // Format date: dd/MM/yyyy
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const dateFormatted = `${day}/${month}/${year}`;
    
    return `${time} - ${dateFormatted}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString; // Return original string if error
  }
};

/**
 * Định dạng chuỗi ngày tháng theo định dạng Việt Nam: "dd/MM/yyyy"
 * @param dateString - Chuỗi ngày tháng ISO hoặc chuỗi ngày tháng
 * @returns Chuỗi ngày tháng đã được định dạng
 */
export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original string if invalid
    }
    
    // Format date: dd/MM/yyyy
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString; // Return original string if error
  }
};

/**
 * Định dạng chuỗi ngày tháng theo định dạng Việt Nam: "HH:mm"
 * @param dateString - Chuỗi ngày tháng ISO hoặc chuỗi ngày tháng
 * @returns Chuỗi thời gian đã được định dạng
 */
export const formatTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original string if invalid
    }
    
    // Format time: HH:mm
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${hours}:${minutes}`;
  } catch (error) {
    console.error('Error formatting time:', error);
    return dateString; // Return original string if error
  }
};

/**
 * Định dạng chuỗi ngày tháng theo định dạng Việt Nam có giây: "HH:mm:ss - dd/MM/yyyy"
 * @param dateString - Chuỗi ngày tháng ISO hoặc chuỗi ngày tháng
 * @returns Chuỗi ngày tháng đã được định dạng có giây
 */
export const formatDateTimeWithSeconds = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return dateString; // Return original string if invalid
    }
    
    // Format time: HH:mm:ss
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    
    // Format date: dd/MM/yyyy
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const dateFormatted = `${day}/${month}/${year}`;
    
    return `${time} - ${dateFormatted}`;
  } catch (error) {
    console.error('Error formatting date time with seconds:', error);
    return dateString; // Return original string if error
  }
};
